// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .time-img-style{

    height:60%;
} */

.image-container-timeseries img {
  width: 100%;
  display: block;
  padding: 5px;
  /* position: relative; */
}

/* .image-container {
    position: relative;
    display: inline-block;
} */

.time-img-style {
  transition: transform 0.3s ease-in-out;
  display: block;
}

.controls {
  position: absolute;
  top: 20%;
  right: 167px;
  transform: translateY(-50%);
  display: flex;
  /* flex-direction: column; */
}

.zoom-button {
  margin: 5px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  box-shadow: 0px 4px 10px 0px #00000066;
  background: #ffffff;
  border-radius: 10px;
}

.collapsible {
  margin-top: 40px;
  margin-bottom: 5px;
  position: absolute;
  right: 0;
  top: 0;
  width: 400px;
  /* height: 99%; */
  max-height: calc(100vh - 62px);
  min-height: calc(100vh - 62px);
  background-color: #161838;
  border-left: 1px solid #423983;
  box-shadow: 0px 4px 10px 0px #000000;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.close-button {
  align-self: flex-end;
  margin: 5px;
  padding: 5px;
  font-size: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: white;
}

.collapsible-content {
  padding: 10px;
  flex-grow: 1;
}

.tabsTime {
  display: flex;
  border-bottom: 3px solid #8f60ff33;
  /* border-bottom: 1px solid #ccc; */
}

.timeseries-ref-name {
  font-size: 16px;
  font-weight: 500;
  margin-left: 12px;
  color: white;
  position: absolute;
  z-index: 2;
  margin-top: 39px;
}

.timeseries-dropdown {
  position: absolute;
  margin-left: 12px;
  margin-top: 13px;
  z-index: 2;
}

.tabTime-button {
  flex: 1 1;
  padding: 2px;
  cursor: pointer;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  font-size: 12px;
  color: #99adc4;
  /* border-bottom: 3px solid #8F60FF33; */
}

.tabTime-button.active {
  /* border: 4px solid #8F60FF */
  border-bottom: 2px solid #8f60ff;
  /* font-weight: bold; */
  background-color: transparent;
  color: white;
}

.collapsible-content {
  padding: 20px;
  flex-grow: 1;
}

.insightTab {
  color: white;
  font-size: 12px;
}

.boldFont-style {
  font-weight: 500;
}

.eqp-head-style {
  margin-top: 20px;
}

.inOutTab {
  border-bottom: 3px solid #8f60ff33;
}

.tab-flow-style {
  margin-top: 10px;
}

.eqipmntTable {
  border-radius: 10px !important;
  /* border-left: 1px solid #423983; */
  box-shadow: 0px 4px 10px 0px #000000;
  margin-top: 10px;
  background: #747ba966;
}

.eqipmntTable td {
  padding-left: 19px;
  padding-right: 19px;
  padding-top: 5px;
  padding-bottom: 5px;
  background: #203546;
}

.eqipmntTable th {
  padding-top: 10px;
  padding-left: 19px;
  padding-right: 18px;
  padding-bottom: 10px;
}

.live-style {
  background-color: red;
  border-radius: 10px;
  padding: 2px;
  padding-left: 4px;
  width: 32px;
  display: inline-grid;
  margin-left: 3px;
}

.toggleText {
  margin-left: 6px;
}

.activeToggletext {
  justify-content: flex-end;
}

.accordianBox {
  /* background-color: #747BA966; */
  padding-left: 0px;
  padding-top: 3px;
  border-radius: 10px;
  padding-bottom: 10px;
}

.activeToggleCircle {
  background-color: #137feb;
  border-radius: 10px;
  margin-top: 4px;
  margin-right: 3px;
  width: 10px;
  height: 10px;
}

.activeToggleForcastCircle {
  background-color: #0cf994;
  border-radius: 10px;
  margin-top: 4px;
  margin-right: 3px;
  width: 10px;
  height: 10px;
}

.allDetailsTxt {
  font-size: 10px;
  text-decoration: underline;
  color: #99adc4;
}

.allDtlDiv {
  display: flex;
  justify-content: flex-end;
}

.graphViewBtn {
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
}

.tableViewBtn {
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
}

.viewICon {
  height: 17px;
  padding: 3px !important;
}

.custom-accordion .accordion-button {
  font-size: 12px;
  color: white;
  font-weight: 700;
  padding-top: 2px;
  padding-bottom: 2px;
  padding-left: 9px; /* Adjust font size if necessary */
  background: #747ba9;
}

.custom-accordion .accordion-button:focus {
  border-color: none;
}

.custom-accordion .accordion-item {
  border: none;
}

.custom-accordion .accordion-header {
}

.custom-accordion .accordion-body {
  padding: 0px;
  overflow: hidden;
  max-height: fit-content;
}

.areaChartContainer {
  padding-left: 5px;
  padding-right: 5px;
}

.settingsIcon {
  width: 23px !important;
  height: 23px;
  margin-left: 188px;
}

.table-container {
  max-height: 180px; /* Set the desired height */
  overflow-y: auto; /* Enable vertical scrolling */
  overflow-x: scroll; /* Enable horizontal scrolling if needed */
  border: 1px solid #ccc; /* Optional: adds a border around the table container */
  border-radius: 10px; /* Optional: adds rounded corners to the container */
  margin-top: 10px; /* Optional: adds some space above the table */
  box-shadow: 0px 4px 10px 0px #000000;
  background: #747ba966;
}

.accordianTable {
  width: 100%;
  border-collapse: collapse;
  border-spacing: 0;
  border-radius: 10px; /* Apply border radius to the table */
  background: #203546; /* Set background for table cells */
}

.accordianTable th,
.accordianTable td {
  padding: 8px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.accordianTable th {
  font-size: 12px;
  padding: 10px 5px;
  background: #747ba9; /* Use a solid color instead of semi-transparent */
  position: sticky;
  top: 0;
  z-index: 3; /* Ensure it's above other elements */
  border: 1px solid white;
}

.accordianTable th.second-row {
  top: 38px; /* Adjust this value based on the height of your first row headers */
  z-index: 2; /* Ensure it's above table body but below the first row of headers */
}

.accordianTable td {
  padding: 5px 10px;
  background: #203546;
}

/* .accordianTable{
    border-radius: 10px !important;
   
    box-shadow: 0px 4px 10px 0px #000000;
    margin-top: 10px;
    background: #747BA966;   
}

.accordianTable td{
    padding-left: 10px;
    padding-right: 19px;
    padding-top: 5px;
    padding-bottom: 5px;
    background: #203546;
}

.accordianTable th{
    font-size: 12px;
    padding-top: 10px;
    padding-left: 5px;
    padding-right: 5px;
    padding-bottom: 10px;
} */

.settingBox {
  padding: 13px;
}

.settingHeader {
  display: flex;
  padding: 5px;
  background: #747ba966;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.settingdata {
  display: flex;
  padding: 7px;
  background: #ffffff1a;
}

.settingAplyBtn {
  justify-content: flex-end;
  display: flex;
}

.settingAplyBtn button {
  border-radius: 16px;
  padding: 6px;
  width: 58px;
  background-color: #8f60ff;
  color: white;
}

.minusBtn {
  background-color: #8f60ff;
  border: none;
  color: white;
  border-radius: 5px;
  margin-right: 5px;
}

.plusBtn {
  background-color: #8f60ff;
  border: none;
  color: white;
  border-radius: 5px;
  margin-left: 5px;
}

/* styles.css */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: #161838;
  padding: 20px;
  border-radius: 10px;
  position: relative;
  width: 800px; /* Custom size */
  height: 420px; /* Custom size */
}

.modal-close {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}

/* styles.css */
/* styles.css */
/* Custom styles for the Highcharts context menu button */
/* styles.css */
/* Custom styles for the Highcharts context menu button */
.highcharts-contextbutton {
  width: 40px !important; /* Adjust the width as needed */
  height: 40px !important; /* Adjust the height as needed */
  padding: 5px !important; /* Adjust padding if needed */
}

.highcharts-contextbutton .highcharts-button-box {
  fill: #2a2a2a !important; /* Change this to your desired background color */
  stroke: #2a2a2a !important; /* Change this to match your background color */
}

.highcharts-contextbutton .highcharts-button-symbol {
  width: 10px !important; /* Adjust the width of the icon */
  height: 10px !important; /* Adjust the height of the icon */
  stroke-width: 1.5 !important; /* Adjust the thickness of the lines */
  stroke: #ffffff !important; /* Change the icon color if needed */
}

.highcharts-contextbutton:hover .highcharts-button-box {
  fill: #444444 !important; /* Change this to your desired hover background color */
  stroke: #444444 !important; /* Change this to match your hover background color */
}

/* ThreeDotsLoader.css */
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.loader-f {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 187px;
  padding-top: 50px;
}

.dot {
  width: 10px;
  height: 10px;
  margin: 0 5px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
}

.red {
  background-color: #8070d4;
  /* Red color */
  animation-delay: -0.32s;
}

.green {
  background-color: #8070d4;
  /* Green color */
  animation-delay: -0.16s;
}

.blue {
  background-color: #8070d4;
  /* Blue color */
}

.loading-text {
  background-color: #3498db;
  /* Red color */
  animation-delay: -0.48s;
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: translateY(0);
  }

  40% {
    transform: translateY(-10px);
  }
}

/* forecast Tab CSS starts */

.forecast-container {
  padding: 3%;
  color: white;
  display: flex;
  flex-direction: column;
  font-size: 16px;
}

.create-button {
  border-radius: 16px;
  width: 180px;
  height: 46px;
  background-color: #161838;
  color: white;
  padding: 7px;
  box-shadow: 2px 2px #fff;
}

.sub-heading {
  display: flex;
  flex-direction: row;
  word-wrap: break-word;
  color: #a2a3ab;
}
.table-container {
  margin-top: 20px;
  background-color: #2d2f4c;
  width: 100%;
  height: 600px;
  /* padding: 22px;
  border-radius: 20px; */
}
.header {
  background-color: #494d71;
}
.row-color {
  background-color: #42435d;
}

#myTable {
  border-collapse: collapse;
  width: 100%;
  font-size: 14px;
}
#myTable th,
#myTable td {
  text-align: left;
  padding: 12px;
}

.hidden-table-style {
  background-color: #343650;
  color: white;
  width: 100%;
  height: auto;
  display: none;
}

.progress-bar {
  width: 100%;
  background-color: #16afb3;
}
.progress {
  height: 18px;
  width: 75%;
  background-image: linear-gradient(#07cd9d, #0fbca9);
}
.publish-button-container {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
}

.publish-button {
  border-radius: 16px;
  padding: 8px;
  width: 70px;
  background-color: #8f60ff;
  color: white;
}
.api-loader {
  animation: spin 4s linear infinite;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}

.loader-text {
  color: white;
  margin-left: 14%;
  font-size: 20px;
}

.collapse-table-header {
  background-color: #343650;
  border-top: 1px solid #42445e;
  border-left: 1px solid #42445e;
  border-right: 1px solid #42445e;
  display: none;
}

.collapse-table-row {
  background-color: #343650;
  border-left: 1px solid #42445e;
  border-right: 1px solid #42445e;
  border-bottom: 1px solid #42445e;
  display: none;
}
.margin-heading{
  margin-bottom: 20px;
}

/* Forecast Tab CSS ends */
`, "",{"version":3,"sources":["webpack://./src/Timeseries/Timeseries.css"],"names":[],"mappings":"AAAA;;;GAGG;;AAEH;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;;GAGG;;AAEH;EACE,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,iBAAiB;EACjB,8BAA8B;EAC9B,8BAA8B;EAC9B,yBAAyB;EACzB,8BAA8B;EAC9B,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,oCAAoC;EACpC,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB,EAAE,kCAAkC;EACrD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;AACA;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,EAAE,2BAA2B;EAC9C,gBAAgB,EAAE,8BAA8B;EAChD,kBAAkB,EAAE,0CAA0C;EAC9D,sBAAsB,EAAE,uDAAuD;EAC/E,mBAAmB,EAAE,oDAAoD;EACzE,gBAAgB,EAAE,8CAA8C;EAChE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB,EAAE,qCAAqC;EAC1D,mBAAmB,EAAE,mCAAmC;AAC1D;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAE,kDAAkD;EACvE,gBAAgB;EAChB,MAAM;EACN,UAAU,EAAE,qCAAqC;EACjD,uBAAuB;AACzB;;AAEA;EACE,SAAS,EAAE,oEAAoE;EAC/E,UAAU,EAAE,oEAAoE;AAClF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;;;;;;;;;;;;;;;;;;;;;GAsBG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,YAAY,EAAE,gBAAgB;EAC9B,aAAa,EAAE,gBAAgB;AACjC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA,eAAe;AACf,eAAe;AACf,yDAAyD;AACzD,eAAe;AACf,yDAAyD;AACzD;EACE,sBAAsB,EAAE,+BAA+B;EACvD,uBAAuB,EAAE,gCAAgC;EACzD,uBAAuB,EAAE,6BAA6B;AACxD;;AAEA;EACE,wBAAwB,EAAE,iDAAiD;EAC3E,0BAA0B,EAAE,+CAA+C;AAC7E;;AAEA;EACE,sBAAsB,EAAE,iCAAiC;EACzD,uBAAuB,EAAE,kCAAkC;EAC3D,4BAA4B,EAAE,sCAAsC;EACpE,0BAA0B,EAAE,oCAAoC;AAClE;;AAEA;EACE,wBAAwB,EAAE,uDAAuD;EACjF,0BAA0B,EAAE,qDAAqD;AACnF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE;;;IAGE,wBAAwB;EAC1B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,4BAA4B;;AAE5B;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb;wBACsB;AACxB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,UAAU;EACV,mDAAmD;AACrD;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,8BAA8B;EAC9B,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;;AAEA,0BAA0B","sourcesContent":["/* .time-img-style{\n\n    height:60%;\n} */\n\n.image-container-timeseries img {\n  width: 100%;\n  display: block;\n  padding: 5px;\n  /* position: relative; */\n}\n\n/* .image-container {\n    position: relative;\n    display: inline-block;\n} */\n\n.time-img-style {\n  transition: transform 0.3s ease-in-out;\n  display: block;\n}\n\n.controls {\n  position: absolute;\n  top: 20%;\n  right: 167px;\n  transform: translateY(-50%);\n  display: flex;\n  /* flex-direction: column; */\n}\n\n.zoom-button {\n  margin: 5px;\n  width: 30px;\n  height: 30px;\n  cursor: pointer;\n  box-shadow: 0px 4px 10px 0px #00000066;\n  background: #ffffff;\n  border-radius: 10px;\n}\n\n.collapsible {\n  margin-top: 40px;\n  margin-bottom: 5px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  width: 400px;\n  /* height: 99%; */\n  max-height: calc(100vh - 62px);\n  min-height: calc(100vh - 62px);\n  background-color: #161838;\n  border-left: 1px solid #423983;\n  box-shadow: 0px 4px 10px 0px #000000;\n  z-index: 1000;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.close-button {\n  align-self: flex-end;\n  margin: 5px;\n  padding: 5px;\n  font-size: 10px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: white;\n}\n\n.collapsible-content {\n  padding: 10px;\n  flex-grow: 1;\n}\n\n.tabsTime {\n  display: flex;\n  border-bottom: 3px solid #8f60ff33;\n  /* border-bottom: 1px solid #ccc; */\n}\n\n.timeseries-ref-name {\n  font-size: 16px;\n  font-weight: 500;\n  margin-left: 12px;\n  color: white;\n  position: absolute;\n  z-index: 2;\n  margin-top: 39px;\n}\n\n.timeseries-dropdown {\n  position: absolute;\n  margin-left: 12px;\n  margin-top: 13px;\n  z-index: 2;\n}\n\n.tabTime-button {\n  flex: 1;\n  padding: 2px;\n  cursor: pointer;\n  background: none;\n  border: none;\n  border-bottom: 2px solid transparent;\n  font-size: 12px;\n  color: #99adc4;\n  /* border-bottom: 3px solid #8F60FF33; */\n}\n\n.tabTime-button.active {\n  /* border: 4px solid #8F60FF */\n  border-bottom: 2px solid #8f60ff;\n  /* font-weight: bold; */\n  background-color: transparent;\n  color: white;\n}\n\n.collapsible-content {\n  padding: 20px;\n  flex-grow: 1;\n}\n\n.insightTab {\n  color: white;\n  font-size: 12px;\n}\n\n.boldFont-style {\n  font-weight: 500;\n}\n\n.eqp-head-style {\n  margin-top: 20px;\n}\n\n.inOutTab {\n  border-bottom: 3px solid #8f60ff33;\n}\n\n.tab-flow-style {\n  margin-top: 10px;\n}\n\n.eqipmntTable {\n  border-radius: 10px !important;\n  /* border-left: 1px solid #423983; */\n  box-shadow: 0px 4px 10px 0px #000000;\n  margin-top: 10px;\n  background: #747ba966;\n}\n\n.eqipmntTable td {\n  padding-left: 19px;\n  padding-right: 19px;\n  padding-top: 5px;\n  padding-bottom: 5px;\n  background: #203546;\n}\n\n.eqipmntTable th {\n  padding-top: 10px;\n  padding-left: 19px;\n  padding-right: 18px;\n  padding-bottom: 10px;\n}\n\n.live-style {\n  background-color: red;\n  border-radius: 10px;\n  padding: 2px;\n  padding-left: 4px;\n  width: 32px;\n  display: inline-grid;\n  margin-left: 3px;\n}\n\n.toggleText {\n  margin-left: 6px;\n}\n\n.activeToggletext {\n  justify-content: flex-end;\n}\n\n.accordianBox {\n  /* background-color: #747BA966; */\n  padding-left: 0px;\n  padding-top: 3px;\n  border-radius: 10px;\n  padding-bottom: 10px;\n}\n\n.activeToggleCircle {\n  background-color: #137feb;\n  border-radius: 10px;\n  margin-top: 4px;\n  margin-right: 3px;\n  width: 10px;\n  height: 10px;\n}\n\n.activeToggleForcastCircle {\n  background-color: #0cf994;\n  border-radius: 10px;\n  margin-top: 4px;\n  margin-right: 3px;\n  width: 10px;\n  height: 10px;\n}\n\n.allDetailsTxt {\n  font-size: 10px;\n  text-decoration: underline;\n  color: #99adc4;\n}\n\n.allDtlDiv {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.graphViewBtn {\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n}\n\n.tableViewBtn {\n  border-top-right-radius: 20px;\n  border-bottom-right-radius: 20px;\n}\n\n.viewICon {\n  height: 17px;\n  padding: 3px !important;\n}\n\n.custom-accordion .accordion-button {\n  font-size: 12px;\n  color: white;\n  font-weight: 700;\n  padding-top: 2px;\n  padding-bottom: 2px;\n  padding-left: 9px; /* Adjust font size if necessary */\n  background: #747ba9;\n}\n\n.custom-accordion .accordion-button:focus {\n  border-color: none;\n}\n\n.custom-accordion .accordion-item {\n  border: none;\n}\n\n.custom-accordion .accordion-header {\n}\n\n.custom-accordion .accordion-body {\n  padding: 0px;\n  overflow: hidden;\n  max-height: fit-content;\n}\n\n.areaChartContainer {\n  padding-left: 5px;\n  padding-right: 5px;\n}\n\n.settingsIcon {\n  width: 23px !important;\n  height: 23px;\n  margin-left: 188px;\n}\n\n.table-container {\n  max-height: 180px; /* Set the desired height */\n  overflow-y: auto; /* Enable vertical scrolling */\n  overflow-x: scroll; /* Enable horizontal scrolling if needed */\n  border: 1px solid #ccc; /* Optional: adds a border around the table container */\n  border-radius: 10px; /* Optional: adds rounded corners to the container */\n  margin-top: 10px; /* Optional: adds some space above the table */\n  box-shadow: 0px 4px 10px 0px #000000;\n  background: #747ba966;\n}\n\n.accordianTable {\n  width: 100%;\n  border-collapse: collapse;\n  border-spacing: 0;\n  border-radius: 10px; /* Apply border radius to the table */\n  background: #203546; /* Set background for table cells */\n}\n\n.accordianTable th,\n.accordianTable td {\n  padding: 8px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n.accordianTable th {\n  font-size: 12px;\n  padding: 10px 5px;\n  background: #747ba9; /* Use a solid color instead of semi-transparent */\n  position: sticky;\n  top: 0;\n  z-index: 3; /* Ensure it's above other elements */\n  border: 1px solid white;\n}\n\n.accordianTable th.second-row {\n  top: 38px; /* Adjust this value based on the height of your first row headers */\n  z-index: 2; /* Ensure it's above table body but below the first row of headers */\n}\n\n.accordianTable td {\n  padding: 5px 10px;\n  background: #203546;\n}\n\n/* .accordianTable{\n    border-radius: 10px !important;\n   \n    box-shadow: 0px 4px 10px 0px #000000;\n    margin-top: 10px;\n    background: #747BA966;   \n}\n\n.accordianTable td{\n    padding-left: 10px;\n    padding-right: 19px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    background: #203546;\n}\n\n.accordianTable th{\n    font-size: 12px;\n    padding-top: 10px;\n    padding-left: 5px;\n    padding-right: 5px;\n    padding-bottom: 10px;\n} */\n\n.settingBox {\n  padding: 13px;\n}\n\n.settingHeader {\n  display: flex;\n  padding: 5px;\n  background: #747ba966;\n  border-top-left-radius: 10px;\n  border-top-right-radius: 10px;\n}\n\n.settingdata {\n  display: flex;\n  padding: 7px;\n  background: #ffffff1a;\n}\n\n.settingAplyBtn {\n  justify-content: flex-end;\n  display: flex;\n}\n\n.settingAplyBtn button {\n  border-radius: 16px;\n  padding: 6px;\n  width: 58px;\n  background-color: #8f60ff;\n  color: white;\n}\n\n.minusBtn {\n  background-color: #8f60ff;\n  border: none;\n  color: white;\n  border-radius: 5px;\n  margin-right: 5px;\n}\n\n.plusBtn {\n  background-color: #8f60ff;\n  border: none;\n  color: white;\n  border-radius: 5px;\n  margin-left: 5px;\n}\n\n/* styles.css */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.modal-content {\n  background: #161838;\n  padding: 20px;\n  border-radius: 10px;\n  position: relative;\n  width: 800px; /* Custom size */\n  height: 420px; /* Custom size */\n}\n\n.modal-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: none;\n  border: none;\n  font-size: 20px;\n  color: #fff;\n  cursor: pointer;\n}\n\n/* styles.css */\n/* styles.css */\n/* Custom styles for the Highcharts context menu button */\n/* styles.css */\n/* Custom styles for the Highcharts context menu button */\n.highcharts-contextbutton {\n  width: 40px !important; /* Adjust the width as needed */\n  height: 40px !important; /* Adjust the height as needed */\n  padding: 5px !important; /* Adjust padding if needed */\n}\n\n.highcharts-contextbutton .highcharts-button-box {\n  fill: #2a2a2a !important; /* Change this to your desired background color */\n  stroke: #2a2a2a !important; /* Change this to match your background color */\n}\n\n.highcharts-contextbutton .highcharts-button-symbol {\n  width: 10px !important; /* Adjust the width of the icon */\n  height: 10px !important; /* Adjust the height of the icon */\n  stroke-width: 1.5 !important; /* Adjust the thickness of the lines */\n  stroke: #ffffff !important; /* Change the icon color if needed */\n}\n\n.highcharts-contextbutton:hover .highcharts-button-box {\n  fill: #444444 !important; /* Change this to your desired hover background color */\n  stroke: #444444 !important; /* Change this to match your hover background color */\n}\n\n/* ThreeDotsLoader.css */\n.loader {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n.loader-f {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n  width: 187px;\n  padding-top: 50px;\n}\n\n.dot {\n  width: 10px;\n  height: 10px;\n  margin: 0 5px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.red {\n  background-color: #8070d4;\n  /* Red color */\n  animation-delay: -0.32s;\n}\n\n.green {\n  background-color: #8070d4;\n  /* Green color */\n  animation-delay: -0.16s;\n}\n\n.blue {\n  background-color: #8070d4;\n  /* Blue color */\n}\n\n.loading-text {\n  background-color: #3498db;\n  /* Red color */\n  animation-delay: -0.48s;\n}\n\n@keyframes bounce {\n  0%,\n  80%,\n  100% {\n    transform: translateY(0);\n  }\n\n  40% {\n    transform: translateY(-10px);\n  }\n}\n\n/* forecast Tab CSS starts */\n\n.forecast-container {\n  padding: 3%;\n  color: white;\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n}\n\n.create-button {\n  border-radius: 16px;\n  width: 180px;\n  height: 46px;\n  background-color: #161838;\n  color: white;\n  padding: 7px;\n  box-shadow: 2px 2px #fff;\n}\n\n.sub-heading {\n  display: flex;\n  flex-direction: row;\n  word-wrap: break-word;\n  color: #a2a3ab;\n}\n.table-container {\n  margin-top: 20px;\n  background-color: #2d2f4c;\n  width: 100%;\n  height: 600px;\n  /* padding: 22px;\n  border-radius: 20px; */\n}\n.header {\n  background-color: #494d71;\n}\n.row-color {\n  background-color: #42435d;\n}\n\n#myTable {\n  border-collapse: collapse;\n  width: 100%;\n  font-size: 14px;\n}\n#myTable th,\n#myTable td {\n  text-align: left;\n  padding: 12px;\n}\n\n.hidden-table-style {\n  background-color: #343650;\n  color: white;\n  width: 100%;\n  height: auto;\n  display: none;\n}\n\n.progress-bar {\n  width: 100%;\n  background-color: #16afb3;\n}\n.progress {\n  height: 18px;\n  width: 75%;\n  background-image: linear-gradient(#07cd9d, #0fbca9);\n}\n.publish-button-container {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n}\n\n.publish-button {\n  border-radius: 16px;\n  padding: 8px;\n  width: 70px;\n  background-color: #8f60ff;\n  color: white;\n}\n.api-loader {\n  animation: spin 4s linear infinite;\n}\n\n@keyframes spin {\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loader-text {\n  color: white;\n  margin-left: 14%;\n  font-size: 20px;\n}\n\n.collapse-table-header {\n  background-color: #343650;\n  border-top: 1px solid #42445e;\n  border-left: 1px solid #42445e;\n  border-right: 1px solid #42445e;\n  display: none;\n}\n\n.collapse-table-row {\n  background-color: #343650;\n  border-left: 1px solid #42445e;\n  border-right: 1px solid #42445e;\n  border-bottom: 1px solid #42445e;\n  display: none;\n}\n.margin-heading{\n  margin-bottom: 20px;\n}\n\n/* Forecast Tab CSS ends */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
